import { useState, useEffect } from 'react'
import { ChevronDown, ChevronUp } from 'lucide-react'
import layoutOf from 'utils/layoutStyle'

import {
  Container,
  Input,
  ArrowContainer,
  ArrowButton
} from './styles'

/*
  Campo de número com a caixa do @cutilei/ui (36 px) e as setas de passo dentro dela. Do `style`
  (o contêiner) valem só as chaves de layout. O `inputStyle` passa direto, para a tela destacar o
  campo, como a duração alterada dos serviços Cutilei.
*/
export default function NumberInput ({
  name,
  value,
  minValue = 0,
  maxValue = 1000,
  step = 1,
  placeholder = '',
  onChange,
  onBlur = () => null,
  disabled = false,
  stepOnly = false,
  style = {},
  inputStyle = {},
  ...props
}) {
  const [inputValue, setInputValue] = useState (value?.toString () || '')

  useEffect (() => {
    if (value !== undefined && value !== null) {
      setInputValue (value.toString ())
    }
  }, [value])

  const addStep = () => {
    if (parseInt (inputValue) === maxValue) return
    const normalized = Math.round (value / step) * step
    onChange (name, Math.min (normalized + step, maxValue))
  }

  const subtractStep = () => {
    if (parseInt(inputValue) === minValue) return
    const normalized = Math.round (value / step) * step
    onChange (name, Math.max (normalized - step, minValue))
  }

  const handleChange = e => {
    const text = e.target.value
    const numericValue = parseInt (text.replace (/\D/g, ''), 10)

    if (!isNaN (numericValue)) {
      if (numericValue <= maxValue) {
        setInputValue (numericValue.toString ())
        onChange (name, numericValue)
      }
    } else if (text === '') {
      setInputValue ('')
    }
  }

  const handleBlur = () => {
    if (inputValue === '' || inputValue < minValue) {
      setInputValue (minValue.toString ())
      onChange (name, minValue)
    }
    onBlur (name)
  }

  return ( 
    <Container style={layoutOf(style)}>
      <Input
        placeholder={placeholder}
        value={inputValue}
        onChange={handleChange}
        onBlur={handleBlur}
        style={inputStyle}
        disabled={stepOnly || disabled}
        $withArrows={!disabled}
        {...props}
      />
      {!disabled && (
        <ArrowContainer>
          <ArrowButton aria-label='Aumentar' onClick={addStep}>
            <ChevronUp size={12} aria-hidden/>
          </ArrowButton>
          <ArrowButton aria-label='Diminuir' onClick={subtractStep}>
            <ChevronDown size={12} aria-hidden/>
          </ArrowButton>
        </ArrowContainer>
      )}
    </Container>
  )
}
